<template>
  <Modal
    :modal="modal"
    @close="$emit('close')"
    @save="save"
    @refresh="initializeCatalogo"
    @search="searchBox = !searchBox"
    :loading="loading"
    fullscreen
    :titleIcons="titleIcons"
  >
    <v-container
      slot="outer-body"
      fluid
      class="pa-0 pt-16 mt-7 white container-height"
      :class="{ 'mt-9': $vuetify.breakpoint.mdAndUp}"
    >
      <Navbar
        :hasBackButton="true"
        :hasTabs="true"
        :tabsHeader="catalogoTabs"
        @tabChanged="tab = $event"
        @backButtonClicked="$emit('close')"
      >
        <template slot="title">
          <Select
            v-model="catalogo"
            dense
            filled
            hide-details
            :items="catalogos"
            return-object
            item-text="catalogo"
            no-data-text="Nenhum catálogo encontrado"
            @change="changeCatalogo"
          />
        </template>
        <template slot="actions">
          <v-btn
            fab text small dark
            :loading="loading"
            @click="getCatalogosAPI"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn text @click="save">
            Salvar
          </v-btn>
          <!-- <Menu
            :items="menuItems"
          /> -->
        </template>
        <template v-if="catalogo">
          <v-row :slot="grupoAtual" no-gutters class="pb-9">
            <v-col cols="12" class="pa-0">
              <v-list-item
                v-for="item of catalogoGrupoAtualItens"
                :key="item.id_produto"
                class="d-block pl-0"
              >
                <v-row>
                  <v-col cols="12" class="d-flex item-catalogo">
                    <div class="produto-image px-4">
                      <v-img
                        :src="item.imagens[0]"
                        :max-height="$vuetify.breakpoint.xs ? '75': '150'"
                        :max-width="$vuetify.breakpoint.xs ? '75': '150'"
                      ></v-img>
                    </div>
                    <div class="produto-descricao body-2">
                      {{ item.descricao }}
                      <div class="produto-unidade font-weight-bold">
                        ({{ item.unidade }})
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" class="text-right title font-weight-medium">
                    {{ item.preco_bruto | price }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="7" class="font-weight-bold title grey lighten-4">
                    <v-row :justify="$vuetify.breakpoint.xs ? 'space-around' : 'space-between'" no-gutters align="center">
                      <v-col cols="4" class="pl-3">
                        <Menu
                          :items="menuProdutoItems"
                          @obterInformacoes="obterInformacoesProduto(item)"
                        />
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                          class="text-right-input"
                          :value="item.qtde_produto"
                          type="number"
                          solo
                          flat
                          hide-details
                          @input="changeQtde($event, item)"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="5" class="pa-0">
                    <v-row no-gutters class="fill-height">
                      <v-col class="d-flex flex-column">
                        <v-btn dark block tile depressed color="grey" @click="decreaseQuantity(item)">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col class="d-flex flex-column">
                        <v-btn dark block tile depressed color="primary" @click="increaseQuantity(item)">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-col>
            <ModalInfoProduto
              :modal="modalInfoProduto"
              :produto="produtoInformacoes"
              :loading="produtoInformacoesLoading"
              @close="closeInformacoesProduto"
            />
          </v-row>
        </template>
      </Navbar>
      <v-footer
        fixed
        class="font-weight-medium"
      >
        <v-col
          class="pa-0"
          cols="12"
        >
          <div class="d-flex justify-space-between align-center">
            <span>{{ quantidadeTotalSelecionado }} Selecionados</span>
            <span>Total: {{ subtotalSelecionado | price }}</span>
          </div>
        </v-col>
      </v-footer>
    </v-container>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Catalogo',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    produtoInformacoes: {
      type: Object,
      default: null
    },
    produtoInformacoesLoading: {
      type: Boolean,
      default: false
    },
    // TODO: Criar rotina para atualizar preços da lista de produtos
    // de acordo com a tabela de preço, lembrar do fallback caso a tabela seja removida
    tabelaPreco: {
      type: Object,
      default: null
    }
  },
  components: {
    Modal: () => import('@/components/shared/Modal2'),
    ModalInfoProduto: () => import('@/components/produtos/ModalInfoProduto'),
    Select: () => import('@/components/shared/Select'),
    Menu: () => import('@/components/shared/Menu'),
  },
  data: () => ({
    tab: '',
    catalogo: null,
    selectedProdutos: [],
    searchBox: false,
    modalInfoProduto: false,
    menuItems: [],
    menuProdutoItems: [
      { title: 'Informações', value: 'obterInformacoes' },
      // { title: 'Unidades', value: 'selecionaUnidades' },
    ]
  }),
  watch: {
    modal(value) {
      if (value) {
        this.initializeCatalogo();
      } else {
        this.resetCatalogo();
      }
    }
  },
  computed: {
    ...mapGetters(['loading', 'catalogos']),
    subtotalSelecionado() {
      return this.selectedProdutos.reduce((acc, cur) => acc += (cur.qtde_produto * cur.preco_bruto), 0);
    },
    quantidadeTotalSelecionado() {
      return this.selectedProdutos.reduce((acc, cur) => acc += Number(cur.qtde_produto), 0);
    },
    titleIcons() {
      return [
        { name: 'mdi-refresh', event: 'refresh', loading: true },
        { name: this.searchBox ? 'mdi-close' : 'mdi-magnify', event: 'search', loading: false },
      ]
    },
    grupoAtual() {
      return this.tab ? this.tab.split('-')[1] : '';
    },
    title() {
      return this.catalogo ? this.catalogo.descricao : '';
    },
    catalogoGrupoAtualItens() {
      const grupoAtual = this.catalogo.estrutura.find(item => item.descricao.includes(this.grupoAtual));
      
      if (grupoAtual && grupoAtual.itens && grupoAtual.itens.length) {
        return grupoAtual.itens;
      }

      return [];
    },
    catalogoTabs() {
      return this.catalogo ?
      this.retornaGrupos() :
      []
    }
  },
  methods: {
    ...mapActions([
      'fetchCatalogos',
      'fetchCatalogosAPI',
    ]),
    changeQtde(qtde, item) {
      const parsedQtde = Number(qtde);

      const produtoJaSelecionado = this.localizaItemSelecionado(item);

      item.qtde_produto = parsedQtde > 0 ? parsedQtde : 0;

      if (produtoJaSelecionado) {
        produtoJaSelecionado.qtde_produto = item.qtde_produto;

        if (produtoJaSelecionado.qtde_produto === 0) {
          this.selectedProdutos = this.selectedProdutos.filter(produto => produto.id_produto !== produtoJaSelecionado.id_produto);
        }
      } else if (!produtoJaSelecionado && parsedQtde > 0) {
        this.selectedProdutos.push(item); 
      }
    },
    closeInformacoesProduto() {
      this.modalInfoProduto = false;
      this.$emit('closeInformacoesProduto');
    },
    obterInformacoesProduto(produto) {
      this.$emit('obterInformacoes', produto);
      this.modalInfoProduto = true;
    },
    changeCatalogo(catalogo) {
      if (this.selectedProdutos.length && confirm('Deseja adicionar os itens selecionados do catálogo atual?')) {
        this.adicionaProdutosSelecionados();
      }

      this.resetCatalogo();

      this.$nextTick(() => {
        this.catalogo = catalogo;
        this.atualizaPrecoCatalogoTabelaPreco();
      });

      this.getCatalogos();
    },
    retornaGrupos() {
      const gruposCatalogo = this.catalogo.estrutura
        .filter(item => item.tipo.includes('GRUPO'))
        .map(grupo => grupo.descricao);

      return gruposCatalogo;
    },
    resetCatalogo() {
      this.selectedProdutos = [];
      this.catalogo = null;
      // this.catalogos = [];
      this.tab = '';
      this.searchBox = false;
    },
    async getCatalogos() {
      await this.fetchCatalogos();
    },
    async getCatalogosAPI() {
      await this.fetchCatalogosAPI();
      this.initializeCatalogo();
    },
    async initializeCatalogo() {
      await this.getCatalogos();
      this.catalogo = this.catalogos && this.catalogos[0];
      this.atualizaPrecoCatalogoTabelaPreco();
    },
    atualizaPrecoCatalogoTabelaPreco() {
      if (!this.tabelaPreco || !this.catalogo) return;

      this.catalogo.estrutura.forEach(estrutura => {
        estrutura.itens.forEach(itemCatalogo => {
          const itemTabelaPreco = this.tabelaPreco.itens.find(
            itemTabelaPreco => itemTabelaPreco.id_produto === itemCatalogo.id_produto && itemTabelaPreco.id_unidade === itemCatalogo.id_unidade
          );

          if (itemTabelaPreco) {
            itemCatalogo.preco_bruto = itemTabelaPreco.preco_venda;
          }
        });
      });
    },
    localizaItemSelecionado(item) {
      return this.selectedProdutos.find(produto => produto.id_produto === item.id_produto);
    },
    decreaseQuantity(item) {
      const produtoJaSelecionado = this.localizaItemSelecionado(item);

      if (produtoJaSelecionado) {
        if (produtoJaSelecionado.qtde_produto > 0) {
          item.qtde_produto--;
          produtoJaSelecionado.qtde_produto = item.qtde_produto;

          if (produtoJaSelecionado.qtde_produto === 0) {
            this.selectedProdutos = this.selectedProdutos.filter(produto => produto.id_produto !== produtoJaSelecionado.id_produto);
          }
        }
      }
    },
    increaseQuantity(item) {
      const produtoJaSelecionado = this.localizaItemSelecionado(item);

      item.qtde_produto++;

      if (!produtoJaSelecionado) {
        this.selectedProdutos.push(item); 
      }
    },
    adicionaProdutosSelecionados() {
      this.$emit('adicionaProdutosSelecionados', this.selectedProdutos);
      this.selectedProdutos = [];
    },
    save() {
      this.adicionaProdutosSelecionados();
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.item-catalogo {
  height: 100px;
}
@media screen and (min-width: 768px) {
  .item-catalogo {
    height: 150px;
  }
}
.container-height {
  height: calc(100vh - 28px);
}
.text-right-input >>> input {
  text-align: right;
}
</style>